import { LEAD_RANK } from '@src/shared/types/lead';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';

export const leadRankFilterConfig = createSimpleFilterConfig({
  facetName: 'rank',
  color: FILTER_COLOR.teal,
  options: Object.values(LEAD_RANK).map((rank) => ({
    label: formatTextForDisplay(rank),
    value: rank,
  })),
});
